import React, { useEffect, useRef } from "react";
import { Box, TextField } from "@mui/material";
import { useTreeModifyContext } from "./TreeDataContext";

function hashCode(s: string) {
  for (var i = 0, h = 0; i < s.length; i++) h = (Math.imul(31, h) + s.charCodeAt(i)) | 0;
  return h;
}

export function RawJsonEditor(props: { gamePieceName: string | null; path: string[]; rawValue: string }) {
  const { saveChangesAtPath } = useTreeModifyContext();
  const inputRef = useRef<HTMLInputElement>(null);

  const [isValidJson, setIsValidJson] = React.useState(true);
  const [lastCheckedValueHash, setLastCheckedValueHash] = React.useState<number>(0);

  function saveRawChanges() {
    const finalPath = props.gamePieceName ? props.path.concat([props.gamePieceName]) : props.path;
    if (inputRef.current) {
      const value = inputRef.current.value;
      try {
        const parsedValue = JSON.parse(value);
        saveChangesAtPath(parsedValue, finalPath);
      } catch (error) {
        console.error("Failed to parse JSON:", error);
      }
    }
  }

  useEffect(() => {
    let timer = setInterval(() => {
      if (inputRef.current) {
        try {
          let hash = hashCode(inputRef.current.value);
          if (lastCheckedValueHash === hash) {
            return;
          }
          setLastCheckedValueHash(hash);
          JSON.parse(inputRef.current.value);
          setIsValidJson(true);
        } catch (error) {
          console.error("Failed to parse JSON:", error);
          setIsValidJson(false);
        }
      }
    }, 1500);
    return () => {
      clearInterval(timer);
    };
  }, [lastCheckedValueHash]);

  function getBorderStyle() {
    return isValidJson ? { border: "5px solid green" } : { border: "5px solid red" };
  }

  return (
    <Box style={getBorderStyle()}>
      <TextField
        fullWidth={true}
        multiline={true}
        defaultValue={props.rawValue}
        inputRef={inputRef}
        onBlur={saveRawChanges}
      />
    </Box>
  );
}
